import {Injectable} from "@angular/core";
import {BehaviorSubject, Observable, Subject} from "rxjs";
import {AuthenticationService} from "../../authentication/authentication.service";
import {map} from "rxjs/operators";

@Injectable({providedIn: "root"})
export class HeaderVisibilityService {

	private headerVisible$: Subject<boolean> = new BehaviorSubject(false);


	constructor(private authService: AuthenticationService) {
	}

	setVisibility(visible: boolean) {
		this.headerVisible$.next(visible);
	}

	isHeaderVisible(): Observable<boolean> {
		return this.headerVisible$.asObservable().pipe(map(visibilityFlag => {
			return this.authService.isDekraEmployeeLogged() ? true : visibilityFlag;
		}));
	}
}
